<!-- eslint-disable linebreak-style -->
<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :height="height"
        :width="width"
        style="width: 100px"
        viewBox="0 0 82.714 37.127"
    >
        <g
            id="Trazado_672"
            transform="translate(-680.55 -220.373)"
            fill="#f7f7f7"
            stroke-miterlimit="10"
        >
            <path
                d="M753.728,257.5H682.769a2.216,2.216,0,0,1-2.023-3.122l6.508-14.535a2.215,2.215,0,0,0,0-1.811L680.746,223.5a2.217,2.217,0,0,1,2.023-3.123h70.959a2.217,2.217,0,0,1,2.023,1.311l7.32,16.347a2.214,2.214,0,0,1,0,1.811l-7.32,16.347A2.216,2.216,0,0,1,753.728,257.5Z"
                stroke="none"
            />
            <path
                d="M 753.7280883789062 256.4998474121094 C 754.2067260742188 256.4998474121094 754.642333984375 256.2176208496094 754.837890625 255.7806243896484 L 762.15771484375 239.4334259033203 C 762.2991943359375 239.1177368164062 762.2991943359375 238.7556457519531 762.1575927734375 238.4396362304688 L 754.8378295898438 222.0925598144531 C 754.6422119140625 221.6554260253906 754.2066040039062 221.3729705810547 753.7280883789062 221.3729705810547 L 682.7694091796875 221.3729705810547 C 682.3490600585938 221.3729705810547 681.9768676757812 221.5753173828125 681.748291015625 221.9281005859375 C 681.519775390625 222.2808837890625 681.4871826171875 222.7031860351562 681.6590576171875 223.0868530273438 L 688.1671752929688 237.6221160888672 C 688.5414428710938 238.45751953125 688.5414428710938 239.4158172607422 688.1672973632812 240.2510833740234 L 681.6589965820312 254.78662109375 C 681.4872436523438 255.1700744628906 681.519775390625 255.5922088623047 681.7481689453125 255.9447937011719 C 681.9766845703125 256.2975463867188 682.3489379882812 256.4998474121094 682.7694091796875 256.4998474121094 L 753.7280883789062 256.4998474121094 M 753.7280883789062 257.4998474121094 L 682.7694091796875 257.4998474121094 C 681.1624755859375 257.4998474121094 680.0896606445312 255.8440856933594 680.746337890625 254.3778686523438 L 687.2545776367188 239.8424224853516 C 687.5127563476562 239.2661285400391 687.5127563476562 238.6072387695312 687.2545776367188 238.0309600830078 L 680.746337890625 223.4954986572266 C 680.0896606445312 222.0292663574219 681.1624755859375 220.3729705810547 682.7694091796875 220.3729705810547 L 753.7280883789062 220.3729705810547 C 754.6012573242188 220.3729705810547 755.3937377929688 220.8866729736328 755.7506103515625 221.6840667724609 L 763.0702514648438 238.0309600830078 C 763.3285522460938 238.6072387695312 763.3285522460938 239.2661285400391 763.0702514648438 239.8424224853516 L 755.7506103515625 256.1893005371094 C 755.3937377929688 256.9866943359375 754.6012573242188 257.4998474121094 753.7280883789062 257.4998474121094 Z"
                stroke="none"
                fill="rgba(201,201,201,0.3)"
            />
        </g>
    </svg>
</template>

<script>
export default {
    props: {
        height: {
            type: Number,
            default() {
                return 37.127;
            },
        },
        width: {
            type: Number,
            default() {
                return 82.714;
            },
        },
    },
};
</script>
